// Copyright (c) 2026 Digital Asset (Switzerland) GmbH and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import React from 'react';
import { Box, Divider, InputAdornment, TextField, Typography } from '@mui/material';
import { ICredPayload, PaidFieldConfig } from './types';

interface PaidCredentialFormProps {
  paidFields: PaidFieldConfig[];
  onChange: (e: React.ChangeEvent<HTMLInputElement>, type: PaidFieldConfig['type']) => void;
  payload: ICredPayload;
}
export const PaidCredentialForm: React.FC<PaidCredentialFormProps> = ({
  payload,
  paidFields,
  onChange,
}) => {
  return (
    <Box sx={{ mt: 1 }}>
      <Divider sx={{ mt: 1, mb: 1 }} />
      {paidFields.map((p) => (
        <Box key={p.name}>
          <Typography color="secondary" fontWeight="bold" variant="caption">
            {p.label}
          </Typography>
          <TextField
            key={p.name}
            variant="outlined"
            size="small"
            fullWidth
            sx={{ mb: 1 }}
            placeholder="0"
            value={payload[p.name]}
            name={p.name}
            helperText={p.helperText}
            error={!!p.helperText}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <Typography variant="body2">{p.adornment}</Typography>
                </InputAdornment>
              ),
            }}
            onChange={(e: React.ChangeEvent<HTMLInputElement>) => onChange(e, p.type)}
            required
          />
        </Box>
      ))}
    </Box>
  );
};
